<template>
  <div v-if="product && product.spec && product.spec.length" class="specs">
    <h3 class="detail-info-title top-title">Specifications</h3>
    <div class="specs-values-column">
      <div v-for="(spec, index) in product.spec" :key="spec.id">
        <div v-if="index < limit_By" class="flex-grid specs-rows">
          <div class="flex-col-4-sm specs-title">
            <span>{{ capitalizeFirstLetter(spec.key) }}</span>
          </div>
          <div class="flex-col-8-sm specs-value">
            <span>{{ spec.value }}</span>
          </div>
        </div>
      </div>
      <div class="flex-grid specs-rows">
        <div class="flex-col-4-sm specs-title">
          <span>SKU No.</span>
        </div>
        <div class="flex-col-8-sm specs-value">
          <span>{{ product.skuNo }}</span>
        </div>
      </div>
      <div class="flex-grid specs-rows">
        <div class="flex-col-4-sm specs-title">
          <span>Box Dimensions</span>
        </div>
        <div class="flex-col-8-sm specs-value">
          <template v-for="(boxDimension, index) in boxDimensions" :key="index">
            <div>{{ boxDimension.height }}"H x {{ boxDimension.width }}"W x {{ boxDimension.depth }}"L</div>
          </template>
        </div>
      </div>
    </div>
    <a v-if="!showAllSpecs" href="javascript:void(0)" class="accent" @click="simple_toggle(default_Limit, product.spec.length)">{{
      limit_By === 2 ? 'More' : 'Less'
    }}</a>
  </div>
</template>

<script>
import { computed } from 'vue';
import Tracking from '@/components/commons/Tracking';
import useExperiment from '@/compositions/useExperiment';

export default {
  name: 'ProductSpecs',
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  emits: [],
  setup() {
    const { getFeatureVariant } = useExperiment();
    const showAllSpecs = computed(() => ['2-column', '2-column-expanded-gallery'].includes(getFeatureVariant('pdp-redesign-2022')));
    return { showAllSpecs };
  },
  data() {
    return {
      default_Limit: 2,
      limit_By: this.showAllSpecs ? this.product.spec.length : 2,
    };
  },
  computed: {
    boxDimensions() {
      if (this.product && this.product.box && this.product.box.length) {
        return this.product.box
          .filter((box) => box.height && box.width && box.depth)
          .map((box) => ({
            height: Math.ceil(box.height),
            width: Math.ceil(box.width),
            depth: Math.ceil(box.depth),
          }));
      }
      return [];
    },
  },

  methods: {
    simple_toggle(defaultLimit, filtersLength) {
      if (this.limit_By === defaultLimit) {
        this.limit_By = filtersLength;
        Tracking.track('PDP_Expand_Spec', { device: window.screen.width < 967 ? 'Mobile' : 'Desktop' });
      } else {
        this.limit_By = defaultLimit;
      }
    },
    capitalizeFirstLetter(key) {
      const separateWord = key.toLowerCase().split(' ');
      for (let i = 0; i < separateWord.length; i++) {
        separateWord[i] = separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
      }
      return separateWord.join(' ');
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.specs {
  .top-title {
    margin-bottom: 0px !important;
  }

  .specs-values-column {
    padding-top: var(--space-0);
    padding-bottom: var(--space-3);

    .specs-rows {
      padding-top: var(--space-3);
      line-height: 150%;

      .specs-title {
        text-transform: none;
        font-family: var(--font-bold);
        font-size: var(--font-size-16);
        padding-right: var(--space-2);
        line-height: 150%;
      }

      .specs-value {
        font-size: var(--font-size-16);
      }
    }
  }
}
</style>
